import type { Booster } from "@hd2/data";
import { useEffect, useState } from "react";

let cache: Booster[] | null = null;
let pending: Promise<Booster[]> | null = null;

async function fetchBoosters(): Promise<Booster[]> {
	if (cache) {
		return cache;
	}
	if (!pending) {
		pending = fetch("/api/boosters")
			.then((r) => r.json() as Promise<{ boosters: Booster[] }>)
			.then((data) => {
				cache = data.boosters;
				return cache;
			});
	}
	return pending;
}

export function useBoosters(): {
	boosters: Booster[];
	loading: boolean;
} {
	const [boosters, setBoosters] = useState<Booster[]>(() => cache ?? []);
	const [loading, setLoading] = useState(cache === null);

	useEffect(() => {
		if (cache) {
			setBoosters(cache);
			setLoading(false);
			return;
		}
		let alive = true;
		fetchBoosters()
			.then((list) => {
				if (alive) {
					setBoosters(list);
					setLoading(false);
				}
			})
			.catch(() => {
				if (alive) {
					setLoading(false);
				}
			});
		return () => {
			alive = false;
		};
	}, []);

	return { boosters, loading };
}
